import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DepartmentStore, DepartmentState } from './department.store';
import { Observable } from 'rxjs';
import { Department } from './models/department.model';

@Injectable({ providedIn: 'root' })
export class DepartmentQuery extends QueryEntity<DepartmentState> {
  constructor(protected store: DepartmentStore) {
    super(store);
  }

  selectDepartments(companyId: number): Observable<Department[]> {
    return this.selectAll({
      filterBy: (entity) => entity.CompanyId === companyId,
    });
  }

  selectDepartment(departmentId: number): Observable<Department | undefined> {
    return this.selectEntity(departmentId);
  }

  getDepartment(departmentId: number): Department | undefined {
    return this.getEntity(departmentId);
  }
}
